<div class="custom-box flex-center" style="width: 100vw; height: 100vh">
  <div *ngIf="loading" class="loader"></div>
</div>
